var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to,_vm._b({tag:"component"},'component',_vm.linkProps(_vm.to,_vm.disabled),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }